export default __webpack_public_path__ + "_/_/public/files/BF_ExpertSearchTermsofUse-Users040118.pdf";